export const profileConstants = {
  GET_EMAIL_LIST_REQUEST: 'PROFILE/GET_EMAIL_LIST_REQUEST',
  GET_EMAIL_LIST_SUCCESS: 'PROFILE/GET_EMAIL_LIST_SUCCESS',
  GET_EMAIL_LIST_FAILURE: 'PROFILE/GET_EMAIL_LIST_FAILURE',

  GET_INVITE_LIST_REQUEST: 'PROFILE/GET_INVITE_LIST_REQUEST',
  GET_INVITE_LIST_SUCCESS: 'PROFILE/GET_INVITE_LIST_SUCCESS',
  GET_INVITE_LIST_FAILURE: 'PROFILE/GET_INVITE_LIST_FAILURE',

  UPDATE_EMAIL_REQUEST: 'PROFILE/UPDATE_EMAIL_REQUEST',
  UPDATE_EMAIL_SUCCESS: 'PROFILE/UPDATE_EMAIL_SUCCESS',
  UPDATE_EMAIL_FAILURE: 'PROFILE/UPDATE_EMAIL_FAILURE',

  SET_DEFAULT_EMAIL_REQUEST: 'PROFILE/SET_DEFAULT_EMAIL_REQUEST',
  SET_DEFAULT_EMAIL_SUCCESS: 'PROFILE/SET_DEFAULT_EMAIL_SUCCESS',
  SET_DEFAULT_EMAIL_FAILURE: 'PROFILE/SET_DEFAULT_EMAIL_FAILURE',

  ADD_EMAIL_REQUEST: 'PROFILE/ADD_EMAIL_REQUEST',
  ADD_EMAIL_SUCCESS: 'PROFILE/ADD_EMAIL_SUCCESS',
  ADD_EMAIL_FAILURE: 'PROFILE/ADD_EMAIL_FAILURE',

  DELETE_EMAIL_REQUEST: 'PROFILE/DELETE_EMAIL_REQUEST',
  DELETE_EMAIL_SUCCESS: 'PROFILE/DELETE_EMAIL_SUCCESS',
  DELETE_EMAIL_FAILURE: 'PROFILE/DELETE_EMAIL_FAILURE',

  SEND_EMAIL_VALIDATION_CODE_REQUEST:
    'PROFILE/SEND_EMAIL_VALIDATION_CODE_REQUEST',
  SEND_EMAIL_VALIDATION_CODE_SUCCESS:
    'PROFILE/SEND_EMAIL_VALIDATION_CODE_SUCCESS',
  SEND_EMAIL_VALIDATION_CODE_FAILURE:
    'PROFILE/SEND_EMAIL_VALIDATION_CODE_FAILURE',

  VERIFY_EMAIL_CODE_REQUEST: 'PROFILE/VERIFY_EMAIL_CODE_REQUEST',
  VERIFY_EMAIL_CODE_SUCCESS: 'PROFILE/VERIFY_EMAIL_CODE_SUCCESS',
  VERIFY_EMAIL_CODE_FAILURE: 'PROFILE/VERIFY_EMAIL_CODE_FAILURE',

  RESET_EMAIL_VALIDATION: 'PROFILE/RESET_EMAIL_VALIDATION',

  RESPOND_TO_INVITE_REQUEST: 'PROFILE/RESPOND_TO_INVITE_REQUEST',
  RESPOND_TO_INVITE_SUCCESS: 'PROFILE/RESPOND_TO_INVITE_SUCCESS',
  RESPOND_TO_INVITE_FAILURE: 'PROFILE/RESPOND_TO_INVITE_FAILURE',

  GET_MY_WORKPLACE_INTERESTS_REQUEST:
    'PROFILE/GET_MY_WORKPLACE_INTERESTS_REQUEST',
  GET_MY_WORKPLACE_INTERESTS_SUCCESS:
    'PROFILE/GET_MY_WORKPLACE_INTERESTS_SUCCESS',
  GET_MY_WORKPLACE_INTERESTS_FAILURE:
    'PROFILE/GET_MY_WORKPLACE_INTERESTS_FAILURE',
}
